import { RefObject, useEffect } from 'react';

export const useOnClickOutside = (
  refs: RefObject<HTMLElement>[],
  handler: (event: MouseEvent) => void,
) => {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      const isInside = refs.some((ref) =>
        ref.current?.contains(event.target as Node),
      );

      const isDropdownIndicator = (event.target as HTMLElement)?.closest(
        '.Select__dropdown-indicator',
      );

      if (!isInside && !isDropdownIndicator) {
        handler(event);
      }
    };

    document.addEventListener('mousedown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [refs, handler]);
};
